module.exports = __webpack_public_path__ + "static/media/er.356da5cd.svg";